import image1 from '../../assets/done-screen/donescreen-1.jpg';
import image2 from '../../assets/done-screen/donescreen-2.jpg';
import image3 from '../../assets/done-screen/donescreen-3.jpg';

type Props = {
  content: React.ReactElement;
};

/**
 * A DoneScreen component
 * @param props
 */
const DoneScreen = (props: Props) => {
  return (
    <div className="DoneScreen">
      {/* Content (generally a CTA) */}
      {props.content}
      {/* Image row */}
      <div className="DoneScreen__image-wrapper">
        <div className="DoneScreen__image" style={{backgroundImage: `url(${image1})`}}>
          {/* Background-image */}
        </div>
        <div className="DoneScreen__image" style={{backgroundImage: `url(${image2})`}}>
          {/* Background-image */}
        </div>
        <div className="DoneScreen__image" style={{backgroundImage: `url(${image3})`}}>
          {/* Background-image */}
        </div>
      </div>
    </div>
  );
};

export default DoneScreen;
